export default {
  backButtonAriaLabel: 'Back',
  sideNavTitle: 'Settings',
  sideNavItemLabelInbox: 'Inboxes',
  sideNavItemLabelMessageTemplates: 'Message Templates',
  sideNavItemLabelMessagingProvider: 'Messaging Provider',
  sideNavItemLabelOtherSettings: 'Other Settings',
  sideNavItemLabelReports: 'Reports'
};
